import React, { useState } from "react";
import { Table, Badge } from "antd";
import { OPERATION_STATUS,OPERATION_COLOR } from "@/constants/util";

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
    onEdit = () => {},
  } = props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns = [
    {
      title: "投放点位",
      dataIndex: "pointName",
      key: "pointName",
    },
    {
      title: "运营商",
      dataIndex: "operateCompanyName",
      key: "operateCompanyName",
    },
    {
      title: "投放周期",
      dataIndex: "cycle",
      key: "cycle",
    },
    {
      title: "运营状态",
      dataIndex: "state",
      key: "state",
      render: (text) => <Badge status={OPERATION_COLOR[text]} text={OPERATION_STATUS[text]} />,
    },
    {
      title: "开始时间",
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: "结束时间",
      dataIndex: "endTime",
      key: "endTime",
    },
  ];

  return (
    <div className="bg-white pt-16 pl-24 pr-24">
      <Table
        rowSelection={null}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
    </div>
  );
};

export default Content;
